import React, { useMemo, useEffect, useState } from 'react';

import DialogComponent from 'app/components/DialogComponent';
import { makeStyles, Grid, Box, Button, CircularProgress } from '@material-ui/core';
import { injectIntl, FormattedMessage } from 'react-intl';
import { generatePath, useHistory } from 'react-router-dom';
import { SERVICES_CODES, SERVICES_PROPERTIES } from 'app/config/services';
import { useDispatch, useSelector } from 'react-redux';
import { updateRequestDetails, clearNewRequest } from 'app/store/slices/requests';
import { updateServiceDetails } from 'app/store/slices/services';
import moment from 'moment';
import _ from 'lodash';

import styles from './styles';
import serviceEndpoints from 'app/api/services/serviceEndpoints';
import helpers from 'app/utils/helpers';
import { fecthActualRevision, fecthAllRevisions } from 'app/store/slices/revisions';
import { ALERTS_TYPES } from 'app/utils/constants';
import { URLS } from 'app/config/urls';
import { setAlertMessage } from 'app/store/slices/forms';
const useStyles = makeStyles(styles);

function Modal(props) {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const { open, onClose, alert = {} } = props;

    const actualRevision = useSelector((state) => state.revisions.details);
    const revisions = useSelector((state) => state.revisions.revisions);
    const allServices = useSelector((state) => state.services.allServices);

    const [sector, setSector] = useState({});
    const [loadingSector, setLoadingSector] = useState(false);
    const [certificationAlert, setCertificationAlert] = useState(false);

    const deadLineDate = useMemo(() => {
        return helpers.extractDateFromRevisions(revisions, actualRevision);
    }, [actualRevision, revisions]);

    const request = useMemo(() => {
        return alert?.originalData?.solicitacao;
    }, [alert.originalData]);

    const service = useMemo(() => {
        return alert.originalData?.solicitacao?.servico;
    }, [alert.originalData]);

    useEffect(() => {
        (async () => {
            if (request?.cdSolicitacao) {
                const promisses = [dispatch(fecthActualRevision(request.cdSolicitacao))];
                promisses.push(dispatch(fecthAllRevisions(request.cdSolicitacao)));
                await Promise.all(promisses);
            }
        })();
    }, [dispatch, request]);

    useEffect(() => {
        (async () => {
            if (
                alert.originalData?.cdTipoAlerta === ALERTS_TYPES.VISTORIA ||
                alert.originalData?.cdTipoAlerta === ALERTS_TYPES.LICENCA
            ) {
                setCertificationAlert(true);
            }
            if (service?.cdServico) {
                setLoadingSector(true);
                try {
                    const response = await serviceEndpoints.getSectorResponsible(service.cdServico);
                    if (response.status === 200) {
                        setSector(response.data);
                        setLoadingSector(false);
                    }
                } catch (error) {
                    setLoadingSector(false);
                }
            }
        })();
    }, [alert, service]);

    const seeRequest = async (req) => {
        let s = service;
        let urlRedirect = URLS.SERVICES;
        if (req) {
            await dispatch(updateRequestDetails(request));
        } else {
            if (allServices.length > 0) {
                if (alert.originalData?.cdTipoAlerta) {
                    if (alert.originalData?.cdTipoAlerta === ALERTS_TYPES.CRC) {
                        s = _.find(allServices, ['cdServico', SERVICES_CODES.RENOVACAO_CADASTRAL]);
                    } else if (alert.originalData?.cdTipoAlerta === ALERTS_TYPES.VISTORIA) {
                        s = _.find(allServices, ['cdServico', SERVICES_CODES.VISTORIA]);
                        await dispatch(clearNewRequest());
                    }
                }
            }
        }
        if (s) {
            dispatch(
                setAlertMessage({
                    cdServico: s.cdServico,
                    message: alert.originalData?.deAlerta,
                }),
            );
            await dispatch(updateServiceDetails(s));
            urlRedirect = SERVICES_PROPERTIES[s.cdServico].url;
        }
        history.push(generatePath(urlRedirect));
    };

    return (
        <DialogComponent
            title={'Aviso'}
            subtitle={`Publicado ${moment.utc(alert.originalData?.dtCadastro).format('DD/MM/YYYY')}`}
            open={open}
            onClose={onClose}>
            <Grid container spacing={1} className={classes.alertContainer}>
                {loadingSector && (
                    <Grid item xs={12}>
                        <div className={classes.centerProgress}>
                            <CircularProgress size={20} />
                        </div>
                    </Grid>
                )}
                {!loadingSector && (
                    <>
                        {sector && Object.keys(sector).length > 0 && (
                            <Grid item xs={12} sm={certificationAlert ? 6 : 4}>
                                <h3>
                                    <FormattedMessage id="LABELS.COMMONS.SENDER" />
                                </h3>
                                <p className={classes.capitalize}>{sector.nmOrgaoSetor?.toLowerCase()}</p>
                            </Grid>
                        )}
                        {request?.cdSolicitacao && (
                            <>
                                <Grid item xs={12} sm={certificationAlert ? 6 : 4}>
                                    <h3>
                                        <FormattedMessage id="LABELS.SERVICES.SERVICE" />
                                    </h3>
                                    <p>{alert.originalData?.solicitacao?.servico?.nmServico}</p>
                                </Grid>
                                {!certificationAlert && (
                                    <>
                                        <Grid item xs={12} sm={4}>
                                            <h3>
                                                <FormattedMessage id="LABELS.SERVICES.REQUEST" />
                                            </h3>
                                            <p>{alert.originalData?.solicitacao?.nuSolicitacaoFmt}</p>
                                        </Grid>
                                        {deadLineDate && deadLineDate !== '' && (
                                            <Grid item xs={12}>
                                                <h3>Data limite:</h3>
                                                <Box color="secondary.main">
                                                    <p>{moment.utc(deadLineDate).format('DD/MM/YYYY')}</p>
                                                </Box>
                                            </Grid>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                        <Grid item xs={12}>
                            <h3>
                                <FormattedMessage id="LABELS.COMMONS.DESCRIPTION" />
                            </h3>
                            <Box color="secondary.main">
                                <p>{alert.originalData?.deAlerta}</p>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Box className={classes.alertButtonContainer}>
                                {!certificationAlert && request?.cdSolicitacao && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disableElevation
                                        onClick={() => seeRequest(true)}
                                        className={classes.alertButtonCta}>
                                        <FormattedMessage id="LABELS.SERVICES.ACCESS_REQUEST_BTN" />
                                    </Button>
                                )}
                                {(certificationAlert || !request?.cdSolicitacao) && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disableElevation
                                        onClick={() => seeRequest(false)}
                                        className={classes.alertButtonCta}>
                                        <FormattedMessage id="LABELS.SERVICES.ACCESS_SERVIICES_BTN" />
                                    </Button>
                                )}
                            </Box>
                        </Grid>
                    </>
                )}
            </Grid>
        </DialogComponent>
    );
}

export default injectIntl(Modal);
